import { useStore } from 'common/store';
import type { UseStoreValues } from 'common/types/store';

/**
 * SCAL-9335 (staff tightening): whether the current user gets the AI review
 * experience - the review side panel, pending-review badge, purple pending
 * citation styling, AI value previews, AI provenance chips, and
 * accept/decline affordances.
 *
 * SCALAR STAFF ONLY (is_staff or is_superuser). Firm roles (Firm Admin,
 * Analyst, Fund Admin) no longer qualify; every non-staff user sees the
 * standard cap table with plain blue citations. An unresolved user (auth
 * state still hydrating) counts as NOT a reviewer, so the review UI can
 * never flash on for a user who should not see it.
 *
 * The backend mirrors this gate: settle endpoints require staff, and the
 * cap-table read payload ships no AI review data to non-staff callers.
 */
const useAiReviewerRole = (): boolean => {
  const [{ user }] = useStore() as UseStoreValues;
  return Boolean(user?.is_superuser || user?.is_staff);
};

export default useAiReviewerRole;
